module.exports = __webpack_public_path__ + "static/media/estimated_balance.41a83afb.svg";